/**
 * 双重预防机制 - 风险设备检验 API
 * 包括：风险设备维护、检验执行、检验信息查询
 */
import request from "@/utils/enhancedRequest";

// ==================== 风险设备维护 ====================

/**
 * 获取风险设备列表（分页）
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getRiskDevicePage(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/page`,
    method: "post",
    data,
  });
}

/**
 * 获取风险设备详情
 * @param {String} id - 设备ID
 * @returns {Promise}
 */
export function getRiskDeviceDetail(id) {
  return request({
    url: `/sa/green/pre/risk-equipment/get?id=${id}`,
    method: "get",
  });
}

/**
 * 创建风险设备
 * @param {Object} data - 设备数据
 * @returns {Promise}
 */
export function createRiskDevice(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/create`,
    method: "post",
    data,
  });
}

/**
 * 更新风险设备
 * @param {Object} data - 设备数据
 * @returns {Promise}
 */
export function updateRiskDevice(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/update`,
    method: "put",
    data,
  });
}

/**
 * 删除风险设备
 * @param {String} id - 设备ID
 * @returns {Promise}
 */
export function deleteRiskDevice(id) {
  return request({
    url: `/sa/green/pre/risk-equipment/delete?id=${id}`,
    method: "delete",
  });
}

// ==================== 检验执行 ====================

/**
 * 获取设备检验任务列表（分页）
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getDeviceInspectionTaskPage(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/page`,
    method: "post",
    data,
  });
}

/**
 * 执行检验
 * @param {Object} data - 检验数据
 * @returns {Promise}
 */
export function createInspection(data) {
  return request({
    url: `/sa/green/pre/risk-equipment-inspections/create`,
    method: "post",
    data,
  });
}

/**
 * 检验记录编辑
 * @param {Object} data - 检验数据
 * @returns {Promise}
 */
export function updateInspection(data) {
  return request({
    url: `/sa/green/pre/risk-equipment-inspections/update`,
    method: "put",
    data,
  });
}

/**
 * 获取检验详情
 * @param {Number} id - 检验记录ID
 * @returns {Promise}
 */
export function getInspectionDetail(id) {
  return request({
    url: `/sa/green/pre/risk-equipment-inspections/get?id=${id}`,
    method: "get",
  });
}

/**
 * 查看检验记录列表
 * @param {Number} equipmentId - 风险设备ID
 * @returns {Promise}
 */
export function getInspectionList(equipmentId) {
  return request({
    url: `/sa/green/pre/risk-equipment-inspections/list?equipmentId=${equipmentId}`,
    method: "get",
  });
}

// ==================== 检验信息查询 ====================

/**
 * 获取设备检验记录列表（分页）- 管理员查询
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function getDeviceInspectionRecordPage(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/page`,
    method: "post",
    data,
  });
}

/**
 * 删除检验记录
 * @param {String} id - 记录ID
 * @returns {Promise}
 */
export function deleteInspectionRecord(id) {
  return request({
    url: `/sa/green/pre/risk-equipment-inspections/delete?id=${id}`,
    method: "delete",
  });
}

/**
 * 获取检验记录详情
 * @param {String} id - 记录ID
 * @returns {Promise}
 */
export function getInspectionRecordDetail(id) {
  return request({
    url: `/sa/safety/inspectionRecord/detail/${id}`,
    method: "get",
  });
}

/**
 * 设备信息导出
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportRiskEquipment(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/export`,
    method: "post",
    data,
  });
}

/**
 * 检验信息导出
 * @param {Object} data - 查询参数
 * @returns {Promise}
 */
export function exportRiskEquipmentInspections(data) {
  return request({
    url: `/sa/green/pre/risk-equipment-inspections/export`,
    method: "post",
    data,
  });
}

/**
 * 导入风险设备
 * @param {Object} data - 导入数据
 *   - file: 文件对象
 * @returns {Promise}
 */
export function importRiskEquipment(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/import`,
    method: "post",
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 获取风险设备检验统计数据
 * @param {Object} data - 查询参数
 *   - projectId: 当前用户项目id
 * @returns {Promise}
 */
export function getRiskEquipmentInspectionStatistics(data) {
  return request({
    url: `/sa/green/pre/risk-equipment/daping/statistics`,
    method: "post",
    data,
  });
}
